import { api, baseUrl } from '../../api';


export const getBarChartApi = async () => {
    const result = await api.get(`${baseUrl}/admin/dashboard/consignment-graph`);
    return result.data;
};